<template>
<div>
  <CModal
    id="error-notification"
    :title="i18nMessage.Oops"
    :show.sync="showErrorMessage"
  >
    {{errorMessage}}
  </CModal>
  <div 
    id="app-spinner-wrapper"
    v-bind:style="[displaySpinner ? {display: ''} : {display: 'none'}]"
  >
    <c-spinner 
      id="app-spinner"
      color="primary"
    />  
  </div>
  <router-view></router-view>
</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

const PageRouter = () => import('@/page-lib/components/PageRouter')

export default {
  name: 'App',
  data() {
    return {
      showErrorMessage: false,
      errorMessage: "",
      displaySpinner: false,
    }
  },
  computed: mapState({
    loggedInUser: state => state.loggedInUser,
    i18nMessage: state => state.i18nMessage,
    errors: state => state.errors,
    loadingCount: state => state.loadingCount,
    pages: state => state.page.pages,
  }),
  methods: {
    ...mapActions({
      listPages: 'page/listPages',
    }),
    redirectToLoginOrHomePage(id) {
      const shouldGoToLoginPage = !id && this.$router.currentRoute.name != 'Login'
      const shouldGoToGomePage = id && this.$router.currentRoute.name == 'Login'
      if (shouldGoToLoginPage) {
        this.$router.push({
          name: 'Login',
        })
      } else if (shouldGoToGomePage) {
        this.$router.push({
          name: 'Home',
        })
      }
    },
  },
  created () {
    this.listPages().then(() => {
      const dynamicRouters = []
      for (const page of this.pages) {
        dynamicRouters.push({
          path: '/page-preview' + page.path,
          name: page.name,
          component: PageRouter,
        })
      }
      this.$router.addRoutes(dynamicRouters)
    })
    if (!this.loggedInUser || !this.loggedInUser.id) {
      this.redirectToLoginOrHomePage(this.loggedInUser.id)
    }
  },
  watch: {
    $route (to, from) {
      if (to.name == null || from.name == null) {
        return
      }
      this.redirectToLoginOrHomePage(this.loggedInUser.id)
    },
    errors(newVal) {
      if (newVal && newVal && newVal.messages) {
        this.showErrorMessage = true
        this.errorMessage = newVal.messages.join("<br/>")
      }
    },
    loadingCount (newVal) {
      if (this.loadingCountTimeout) clearTimeout(this.loadingCountTimeout)
      this.loadingCountTimeout = setTimeout(() => {
        if (newVal > 0) {
          this.displaySpinner = true
        } else {
          this.displaySpinner = false
        }
      }, 500)
    },
  },
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';

  #error-notification .modal-footer {
    display: none;
  }
  #app-spinner-wrapper {
    z-index: 9999;
    position: fixed;
    width: 100%;
    height:100%;
    display: flex;
    align-items: center;
    top: 0;
    background-color: #eee;
    opacity: 0.5;
  }
  #app-spinner {
    width: 4rem;
    height: 4rem;
    display: flex;
    margin: 0 auto;
  }
</style>